import { render } from "./BulkCampaignsList.vue?vue&type=template&id=a47dcc0a&scoped=true"
import script from "./BulkCampaignsList.vue?vue&type=script&lang=ts"
export * from "./BulkCampaignsList.vue?vue&type=script&lang=ts"

import "./BulkCampaignsList.vue?vue&type=style&index=0&id=a47dcc0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a47dcc0a"

export default script